var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.activeOverlay
    ? _c(
        "VideoPlayerOverlaysWrapper",
        { attrs: { "data-ui-section": "overlay" } },
        [
          _vm.presentationComponent && _vm.presentationOverlay
            ? _c(_vm.presentationComponent, {
                ref: "overlayInner",
                tag: "Component",
                attrs: {
                  "data-ui-section": _vm.presentationOverlay.name,
                  video: _vm.videoStoreState.video,
                  error: _vm.videoStoreState.error,
                  overlay: _vm.presentationOverlay
                },
                on: {
                  shown: _vm.shown,
                  action: _vm.action,
                  dismiss: _vm.dismiss
                }
              })
            : _c("OverlayLoadingOverlay", {
                attrs: {
                  video: _vm.videoStoreState.video,
                  overlay: _vm.activeOverlay
                }
              })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }